'use client'

import Cookies from 'js-cookie'
import { useEffect } from 'react'

const LEGACY_SESSION_STORAGE_COOKIE = 'session-storage'

function removeLegacySessionStorageFromBrowser() {
  const hostname = window.location.hostname
  const removeOptions = [{ path: '/' }, { path: '/', domain: hostname }]

  if (hostname.includes('.')) {
    removeOptions.push({ path: '/', domain: `.${hostname}` })
  }

  Cookies.remove(LEGACY_SESSION_STORAGE_COOKIE)
  for (const options of removeOptions) {
    Cookies.remove(LEGACY_SESSION_STORAGE_COOKIE, options)
  }

  localStorage.removeItem(LEGACY_SESSION_STORAGE_COOKIE)
}

/** Wipes leftover zustand `session-storage` cookie/localStorage from old clients. */
export function ClearLegacySessionCookie() {
  useEffect(() => {
    removeLegacySessionStorageFromBrowser()
  }, [])

  return null
}
